import React, { useEffect, useState } from "react";
import CameraIcon from "../../assets/camera_icon.png";
import CircleLoader from "../CircleLoader/CircleLoader";
import "./RequestingPermissionModal.scss";
import GeneralModal from "../GeneralModal/GeneralModal";
import { useGlobalContext } from "../../scanview/ScanViewerContext";
import { isMobile } from "react-device-detect";

export type RequestingPermissionModalProps = {
  show: boolean;
};

export type RequestPermissionModalConfig = {
  title?: string;
  text?: string;
};

const RequestingPermissionModal = ({
  show,
}: RequestingPermissionModalProps) => {
  const { requestPermissionModalConfig, fullScreen, changeAriaLiveMessage } =
    useGlobalContext();
  const [texts, setTexts] = useState({
    title: "Waiting for Camera Permission",
    text: "Click Allow to grant camera permission",
  });

  useEffect(() => {
    if (requestPermissionModalConfig) {
      setTexts((prev) => ({ ...prev, ...requestPermissionModalConfig }));
    }
  }, [requestPermissionModalConfig]);

  useEffect(() => {
    changeAriaLiveMessage("Loading");
  }, []);

  return (
    <GeneralModal show={show}>
      <div
        data-testid="requesting-permission"
        className={`requestingPermissionModalMainContainer ${
          isMobile ? "mobile" : ""
        }
        ${!fullScreen && !isMobile ? "noFullScreen" : ""}`}
      >
        <img className={"icon"} src={CameraIcon} alt="camera with sparkles" />
        <h2 className={"modalTitle"}>{texts.title}</h2>
        <p className={"modalText"}>{texts.text}</p>
        <CircleLoader />
      </div>
    </GeneralModal>
  );
};

export default RequestingPermissionModal;
